const brCurrencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

/**
 * Formats a numeric value into Brazilian Real (BRL) currency.
 *
 * Converts a value in cents to a BRL currency string (e.g., `12345` → `R$ 123,45`).
 * Handles positive, negative, and zero values, ensuring proper formatting.
 *
 * @param value - Numeric value in cents (e.g., `1` = `R$ 0,01`).
 * @returns Formatted currency string in BRL.
 *
 * @example
 * ```ts
 * toCurrency(12345); // 'R$ 123,45'
 * toCurrency(-12345); // '-R$ 123,45'
 * ```
 */
export function toCurrency(value: number) {
  const isNegativeAmount = value < 0
  const formattedCurrency = brCurrencyFormatter.format(Math.abs(value) / 100)
  const amount = formattedCurrency.replace(/\u00A0/g, ' ')
  return isNegativeAmount ? `-${amount}` : amount
}
